module.exports = __webpack_public_path__ + "img/locked.7331de64.svg";